import React from 'react'
import PropTypes from 'prop-types'

function BusinessBanner({ pageName }) {
  return (
    <div className={`card card--interactive business-banner business-banner--${pageName}`}>
      <a
        // eslint-disable-next-line max-len
        href="https://www.modelry.ai/how-to-order-custom-3d-models?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=enterprise_solutions&utm_creative_format=footer_hero_banner&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
        className="banner__link"
      >
        <h2 className="banner__title">
          CGTrader Enterprise Solutions
        </h2>

        <ul className="banner__services-list">
          <li>Sourcing 3D Assets for Large Projects</li>
          <li>3D Content Production</li>
          <li>Professional 3D Support</li>
          <li>Dedicated Account Management</li>
        </ul>

        <div className="banner__cta">
          <span className="btn btn-outline-white btn-fat btn-cta">Learn more</span>
        </div>
      </a>
    </div>
  )
}

BusinessBanner.propTypes = {
  pageName: PropTypes.string.isRequired,
}

export default BusinessBanner
